var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.912109 17.696L0.912109 0.654451L2.89793 0.654451V2.54537C4.72599 0.602006 6.87884 -0.0244134 9.39359 0.462155C11.0183 0.78786 12.4536 1.67706 13.4147 2.95327C14.4472 4.26885 14.9401 5.89162 14.8025 7.52252C14.665 9.15341 13.9062 10.6825 12.6662 11.828C10.535 13.8326 6.28495 14.6979 2.92576 11.4201L2.92576 17.696H0.912109ZM7.76348 2.16077C4.96107 2.16077 2.78966 4.28769 2.79276 7.00023C2.78168 7.63254 2.90428 8.2606 3.15343 8.84783C3.40259 9.43506 3.7733 9.96972 4.24398 10.4207C4.71467 10.8716 5.27591 11.2298 5.89502 11.4745C6.51413 11.7191 7.17872 11.8452 7.85009 11.8455C10.5906 11.831 12.8208 9.62828 12.7992 6.95653C12.8074 6.32902 12.6831 5.70622 12.4336 5.12432C12.1842 4.54242 11.8144 4.013 11.3459 3.56681C10.8774 3.12063 10.3195 2.76657 9.70449 2.5252C9.0895 2.28383 8.42973 2.15995 7.76348 2.16077Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.0491,
    y1: 2.62038,
    x2: 0.21073,
    y2: 14.9504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8F261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88DB3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoP);
export default __webpack_public_path__ + "static/media/logo-p.2fc1606c86886a4da8c77b14680ce03f.svg";
export { ForwardRef as ReactComponent };